import { Roles } from "./Roles"
import Users from "../components/createUser/Users"
import ro from "../components/ro/RoUser"
import Invoice from "../components/invoice/Invoice"
import CampaignCategories from "../components/campaign/CampaignCategories";
import Campaign from "../components/campaign/Campaign"
import Reports from "../components/reports/Reports"
import CampaignDiscount from '../components/discount/CampaignDiscount'
import Dashboard from "../components/dashboard/Dashboard"
import AddCreative from "../components/creatives/AddCreative"
import PositionalPrice from "../components/campaign/PositionalPrice";
import Queued from "../components/networkads/Queued";
import Approved from "../components/networkads/Approved";
import Blocked from "../components/networkads/Blocked";
import Birdview from "../components/birdview/birdview";
import { roles } from "../utils/constants";
import NewsStream from "../components/campaign/NewsStream";
import Contacts from '../components/birdview/birdViewContact'
import Home from "../components/Designer/DesignerHome";
import Requests from "../components/birdview/b2b_requests";
import AgencyData from "../components/birdview/AgencyData";
import CompetitorData from "../components/birdview/CompetitorData"
import AdsPrices from "../components/reporterAds/AdsPrices";
import ReporterAds from "../components/reporterAds/reporterAds";
import PosWiseImpress from "../components/campaign/PositionwiseImpressions"
import DefaultTab from "../components/birdview/default";
import CompetitorReports from "../components/birdview/competitor_reports";
import b2bIcon from "../assets/images/b2b.svg";
import competitorIcon from "../assets/images/competitor.svg";
import requestIcon from "../assets/images/request.svg";
import nationalIcon from "../assets/images/national.svg";
import InfoIcon from "../assets/images/info.svg"
import agencyIcon from "../assets/images/agency_data.svg";
import AppStats from "../components/Stats/AppStats";
import LineItems from "../components/lineItems/LineItems";
import order from "../components/Orders/Order"
import DownloadCreativePreviews from "../creativePreviews/DownloadCreativePreviews";
import DiscountApproveCampaigns from "../components/lineItems/DiscountApproveCampaigns";
import AdUnit from "../components/adUnits/AdUnit";
import DiscountRanges from "../components/lineItems/DiscountRanges";
import AdRequests from '../components/adRequests/AdRequests'
import lineItemsPlacements from '../components/lineItemsPlacements/lineItemsPlacements'
import Brands from "../components/brands/Brands";
import Impressions from '../components/reports/PositionwiseImpressions'
import AccountManagement from "../components/SalesPanel/AccountManagement";
import EffortAnalysis from '../components/SalesPanel/EffortAnalysis'
import MarketSpendTracker from "../components/SalesPanel/MarketSpendTracker";
import MarketShareAnalysis from "../components/SalesPanel/MarketShareAnalysis";
import MyPerfomance from "../components/SalesPanel/MyPerfomance";
import MyIncentives from "../components/SalesPanel/MyIncentives";
import SalesDashBoard from "../components/SalesPanel/SalesDashBoard";
import PageRates from '../components/birdview/pageRates'
import Editions from '../components/birdview/newspaperEditions'
import SalesContacts from "../components/SalesPanel/SalesContacts";
import RevenueAnalysis from "../components/SalesPanel/RevenueAnalysis";
import NewsPapers from "../components/birdview/NewsPapers";
import TeamManagement from "../components/SalesPanel/TeamManagement";
import FinanceDashboard from "../components/financePanel/FinanceDashboard";
import FinanceReports from "../components/financePanel/FinanceReports";
import BrandsReport from "../components/SalesPanel/BrandsReport";
import PriceCalculator from "../components/CardLists/PriceCalculator";
import SalesSlotBooking from "../components/salesBooking/SalesSlotBooking";
import MauDau from "../components/Stats/MauDau";
import SalesPriceCardList from "../components/CardLists/SalesPriceCardList";
import SalesPriceCalculator from "../components/CardLists/SalesPriceCalculator";
import NationalPlanning from "../components/PlanningTabs/NationalPlanning";
import BuildupSheet from "../components/PlanningTabs/BuildupSheet";
import PlanningReports from "../components/PlanningTabs/PlanningReports";
import EffortAnalysisDashboard from "../components/SalesPanel/EffortAnalysisDashboard";
import CampaignInfo from "../components/campaign/CampaignInfo";
import Help from "../components/SalesPanel/Help";
import HourlyStats from "../components/hourlyStats/HourlyStats";
import MonthlyReports from "../components/PlanningTabs/MonthlyReports";
import CompetitorDataAI from "../components/birdview/CompetitorDataAI";
import AlphaBirdview from "../components/birdview/AlphaBirdview";
import BirdViewReject from "../components/birdview/BirdViewReject";
import SalesReports from "../components/PlanningTabs/SalesReports";
import Inventory from "../components/inventory/Inventory";
import AdPartners from "../components/NetworkPanel/AdPartners";
import SalesCoverage from "../components/SalesPanel/SalesCoverage";
import AdResponses from "../components/inventory/AdResponses";
import DesignerTab from "../components/Designer/DesignerTab";
import SalesWiseInteractions from "../components/Stats/SalesWiseInteractions";
import AdCodeAlerts from "../components/inventory/AdCodeAlerts";
import AlphaPositionalPrice from "../components/campaign/AlphaPositionalPrice";
import ClassifiedPositionalPrice from "../components/campaign/ClassifiedPositionalPrice";
import UnifiedPositionalPrice from "../components/campaign/UnifiedPositionalPrice";
import WebViewUpload from "../components/creatives/WebView/WebViewUpload";
import NetworkReportHourly from "../components/adRequests/NetworkReportHourly";
import NewspaperViewerAlpha from "../components/birdview/NewspaperViewer/NewspaperViewer";
import NewspaperViewer from "../components/birdview/NewspaperViewer";
import CustomReports from "../components/reports/custom_reports/CustomReports";
import ContentWriterHome from "../components/ContentWriter/ContentWriterHome";
import RedisObjects from "../components/Redis/RedisObjects";
import AlphaCompetitorReports from "../components/birdview/AlphaCompetitor_reports";
import InboundVernacular from "../components/SalesPanel/InboundVernacular";
import BrandLocations from "../components/brands/BrandLocations";
import EenaduPageRates from "../components/birdview/EenaduPageRates";
import { components } from "react-select";
import PhionexReports from "../components/PhionexReports/PhionexReports";
import Zones from "../components/Zones/Zones"
import AdCodeStats from "../components/adUnits/AdCodeStats";
import CategoryUpdater from "../components/lineItems/CategoryUpdater";
import CashfreePaymentLinkCreation from "../components/CashfreePaymentLinkCreation/CashfreePaymentLinkCreation";
import LiveCampaigns from "../components/lineItems/LiveCampaigns";

export const PrivateRoutesConfig = [
    {
        id: 7,
        component: Dashboard,
        path: "/home/dashboard",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="home"></sl-icon>Dashboard</span>,
        permission: [roles.advertiser]
    },
    {
        id:39,
        component:SalesDashBoard,
        path:"/home/sales/dashboard",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="bar-chart"></sl-icon>DashBoard</span>,
        permission:[roles.salesperson,]
    },
    {
        id:33,
        component:AccountManagement,
        path:"/home/sales/account",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="user"></sl-icon>Account Management</span>,
        permission:[roles.salesperson, roles.ops]
    },
    {
        id:34,
        component:EffortAnalysisDashboard,
        path:"/home/sales/effortdashboard",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="trending-up"></sl-icon>Effort Analysis</span>,
        permission:[roles.salesperson]   
    },
    {
        id:35,
        component:MarketSpendTracker,
        path:"/home/sales/market-tracker",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="indian-rupee"></sl-icon>Market Tracker</span>,
        permission:[roles.salesperson,]
    },
    {
        id:36,
        component:MarketShareAnalysis,
        path:"/home/sales/market-share",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="pie-chart"></sl-icon>Market-Share Analysis</span>,
        permission:[roles.salesperson]
    },
    {
        id:67,
        component:SalesCoverage,
        path:"/home/sales/coverage",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-ordered"></sl-icon>Sales Coverage</span>,
        permission:[roles.salesperson]
    },
    {
        id:90,
        component:LiveCampaigns,
        path: "/home/livecampaigns",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" className='nav-icons' name="bar-chart-2"></sl-icon>{" "}Live Campaigns</span >,
        permission: [roles.salesperson]
    },
    {
        id:37,
        component:MyPerfomance,
        path:"/home/sales/perfomance",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="gauge"></sl-icon>My Performance</span>,
        permission:[roles.salesperson,]
    },
    {
        id:38,
        component:MyIncentives,
        path:"/home/sales/incentives",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="award"></sl-icon>My Incentives</span>,
        permission:[roles.salesperson,]
    },
    {
        id:31,
        component: Brands,
        path: "/home/brands",
        title: <span className="text-base d-center"><sl-icon library="lucide" className='nav-icons' name="megaphone"></sl-icon> {" "}Brands</span>,
        permission: [roles.b2b, roles.salesperson]
    },
    {
        id: 44,
        component: NewsPapers,
        path: "/home/newspaper_data",
        title: <span className="text-base d-center"><sl-icon library="lucide" className='nav-icons' name="book"></sl-icon>{" "}News Papers</span>,
        permission: [roles.b2b]
    },
    {
        id:57,
        component:PlanningReports,
        path:'/home/brandreports',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="bar-chart"></sl-icon>Yearly Reports</span>,
        permission:[roles.b2b, roles.salesperson]
    },
    {
        id:59,
        component:MonthlyReports,
        path:'/home/monthlyreview',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="trending-up"></sl-icon>Monthly Reports</span>,
        permission:[roles.b2b, roles.salesperson]

    },
    {
        id:63,
        component:SalesReports,
        path:'/home/salesreports',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="trending-up"></sl-icon>Sales Reports</span>,
        permission:[roles.b2b, roles.salesperson]
    },
    {
        id:58,
        component:Help,
        path:'/home/help',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="help-circle"></sl-icon>Tickets</span>,
        permission:[roles.b2b, roles.salesperson]
    },
    {
        id:42,
        component:SalesContacts,
        path:"/home/sales/contacts",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="contact"></sl-icon>Contacts</span>,
        permission:[roles.salesperson,]
    },
    {
        id:43,
        component:RevenueAnalysis,
        path:"/home/sales/revenue",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="indian-rupee"></sl-icon>Revenue Analysis</span>,
        permission:[roles.salesperson,]
    },
    {
        id:46,
        component:FinanceDashboard,
        path:'/home/finance/dashboard',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>Dashboard</span>,
        permission:[roles.financer]
    },
    {
        id:24,
        component:order,
        path:"/home/order",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-ordered"></sl-icon> {" "}Order</span>,
        permission: [roles.financer, roles.ops, roles.advertiser, roles.salesperson, roles.legalperson]
    },
    {
        id:71,
        component:DownloadCreativePreviews,
        path:"/home/download_creative_previews",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="download"></sl-icon> {" "}Creative Previews</span>,
        permission: [roles.ops]
    },
    {
        id: 74,
        component: Contacts,
        path: "/home/saleswise_interactions",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="download"></sl-icon> Sales Wise Interactions</span>,
        permission: [roles.b2b]
    },
    {
        id: 75,
        component: Home,
        path: "/home/designer",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="home"></sl-icon> DashBoard</span>,
        permission: [roles.designer]
    },
    {
        id: 81,
        component:ContentWriterHome,
        path:"/home/content_writer",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="home"></sl-icon> DashBoard</span>,
        permission: [roles.content_writer]
    },
    {
        id:52,
        component:SalesSlotBooking,
        path:"/home/slotbooking",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="calendar"></sl-icon>{" "}{(localStorage.getItem('role') === roles.financer) ? 'Order Approval' : 'Order Booking' }</span>,
        permission:[roles.salesperson, roles.financer, roles.ops]
    },
    {
        id:54,
        component:SalesPriceCalculator,
        path:'/home/salespricecalculator',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="indian-rupee"></sl-icon>Sales Price Calculator</span>,
        permission:[roles.salesperson]
    },
    // {
    //     id:51,
    //     component:"/home/slotapproval",
    //     path:"/home/slotapproval",
    //     title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="calendar"></sl-icon>Slot Approval</span>,
    //     permission:[roles.financer, roles.salesperson]
    // },
    {
        id: 25,
        component: LineItems,
        path: "/home/lineitems",
        title : <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>LineItems</span>,
        permission: [roles.ops, roles.financer]
    },
    {
        id:47,
        component:FinanceReports,
        path:'/home/finance/reports',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>Finance Reports</span>,
        permission:[roles.financer]
    },
    {
        id: 6,
        component: AddCreative,
        path: "/home/creatives",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="image-plus"></sl-icon> {" "}Creatives</span>,
        permission: [roles.ops]
    },
    {
        id: 77,
        component: DesignerTab,
        path: "/home/alpha-designer",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="figma"></sl-icon> {" "}Alpha Designers</span>,
        permission: [roles.ops]
    },
    {
        id: 15,
        component: WebViewUpload,
        path: "/home/creatives/webviewupload",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" name="upload"></sl-icon>Webview Upload</span >,
        permission: [roles.ops]
    },
    {
        id: 27,
        component: AdUnit,
        path: "/home/adunit",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="megaphone"></sl-icon> {" "}Ad Unit</span>,
        permission: [roles.ops]
    },
    {
        id: 30,
        component: lineItemsPlacements,
        path: "/home/placements",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="megaphone"></sl-icon> {" "}Placements</span>,
        permission: [roles.ops]
    },
    {
        id: 32,
        component: Impressions,
        path: "/home/reports/position_impressions",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="bar-chart"></sl-icon> {" "}Positionwise Impressions</span>,
        permission: [roles.ops]
    },
    {
        id: 64,
        component: RedisObjects,
        path: "/home/redis-objects",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="megaphone"></sl-icon> {" "}Redis Objects</span>,
        permission: [roles.ops]
    },
    {
        id: 69,
        component: AdCodeStats,
        path: "/home/ad_code_stats",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="bar-chart"></sl-icon> {" "}Ad Code Stats</span>,
        permission: [roles.ops,roles.financer]
    },
    {
        id: 2,
        component: Reports,
        path: "/home/creative-reports",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="clipboard-list"></sl-icon> {" "}Reports</span>,
        permission: [roles.ops, roles.financer]
    },

    {
        id: 21,
        component: PosWiseImpress,
        path: "/home/positionwise-impressions",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" className='nav-icons' name="bar-chart"></sl-icon>{" "}Impressions</span >,
        permission: [roles.ops]
    },
    {
        id: 22,
        component: AppStats,
        path: "/home/app-stats",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" className='nav-icons' name="bar-chart-2"></sl-icon>{" "}{localStorage.getItem('role') !== roles.salesperson ? "App Stats" : "View Stats"}</span >,
        permission: [roles.ops, roles.salesperson]
    },
    {
        id: 88,
        component: CategoryUpdater,
        path: "/home/category-update",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" className='nav-icons' name="bar-chart-2"></sl-icon>{" "}Category Update</span >,
        permission: [roles.ops]
    },
    
    // {
    //     id: 9,
    //     component: PositionalPrice,
    //     path: "/home/location_prices",
    //     title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Card Lists</span>,
    //     permission: [roles.financer, roles.ops]
    // },
    //  {
    //     id: 78,
    //     component: AlphaPositionalPrice,
    //     path: "/home/alpha_location_prices",
    //     title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Alpha Card Lists</span>,
    //     permission: [roles.financer, roles.ops]
    // },
    // {
    //     id: 79,
    //     component: ClassifiedPositionalPrice,
    //     path: "/home/classified_location_prices",
    //     title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Classified Card Lists</span>,
    //     permission: [roles.financer, roles.ops]
    // },
    {
        id: 80,
        component: UnifiedPositionalPrice,
        path: "/home/unified_location_prices",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Card Lists Management</span>,
        permission: [roles.financer, roles.ops]
    },
    {
        id: 86,
        component: CustomReports,
        path: "/home/custom_reports",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Custom Reports</span>,
        permission: [roles.ops]
    },
    {
        id:85,
        component:Zones,
        path:'/home/zones',
        title: <span className="text-base d-center"><sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Zones</span>,
        permission:[roles.ops, roles.financer]
    },
    {
        id:50,
        component: NetworkReportHourly,
        path: "/home/adcode_hourly",
        title: < span className="text-base  d-center" > <sl-icon library="lucide" className='nav-icons' name="bar-chart-2"></sl-icon>{" "}Adcode Hourly Stats</span >,
        permission: [roles.ops]
    },
    {
        id:53,
        component:SalesPriceCardList,
        path:"/home/sales_location_prices",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-plus"></sl-icon> {" "}Sales CardList</span>,
        permission:[roles.financer]
    },
    {
        id: 8,
        component: CampaignCategories,
        path: "/home/campaign-categories",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-list"></sl-icon> {" "}Campaign Categories</span>,
        permission: [roles.ops]
    },
    {
        id: 1,
        component: Users,
        path: "/home/users",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="users"></sl-icon> {" "}{localStorage.getItem('role') !== roles.financer ? 'Users' : 'Customers' }</span>,
        permission: [roles.salesperson, roles.financer,roles.b2b]
    },
    {
        id: 26,
        component: DiscountApproveCampaigns,
        path: "/home/lineitems/discountApprove",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="cast"></sl-icon> {" "}Discount Approvals</span>,
        permission: [roles.salesperson, roles.legalperson,roles.ops]
    },
    {
        id: 28,
        component: DiscountRanges,
        path: "/home/discountranges",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="cast"></sl-icon> {" "}Discount Management</span>,
        permission: [roles.ops]
    },
    {
        id: 14,
        component: NewsStream,
        path: "/home/newstream",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="cast"></sl-icon> {" "}NewsStream</span>,
        permission: [roles.ops]
    },
    {
        id: 20,
        component: ReporterAds,
        path: "/home/ads_price_location/getAdsAmounts",
        title: < span className="  d-center" > <sl-icon library="lucide" className='nav-icons' name="users"></sl-icon>{" "}Reporter Ads</span >,
        permission: [roles.ops]
    },
    {
        id: 29,
        component: AdRequests,
        path: "/home/adrequest/getAdRequests",
        title: <span className="text-base d-center"><img src={requestIcon} style={{ width: "15px" }} alt="" /> {" "}Ad Requests</span>,
        permission: [roles.ops]
    },
    {
        id:49,
        component:PriceCalculator,
        path:'/home/pricecalculator',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="indian-rupee"></sl-icon>Price Calculator</span>,
        permission:[roles.ops]
    },
    {
        id:51,
        component:MauDau,
        path:'/home/maudau',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="users"></sl-icon>MAU/DAU</span>,
        permission:[roles.ops]
    },
    // {
    //     id: 60,
    //     component: CompetitorDataAI,
    //     path: "/home/birdviewai",
    //     title: < span className=" d-center" > <sl-icon library="lucide" className="nav-icons" name="bot"></sl-icon>{" "}Under Review</span >,
    //     permission: [roles.b2b]
    // },
    {
        id: 87,
        component: NewspaperViewer,
        path: "/home/newspaper-viewer",
        title: < span className=" d-center" > <sl-icon library="lucide" className="nav-icons" name="bot"></sl-icon>{" "}Newspaper Viewer</span >,
        permission: [roles.b2b] 
    },
    {
        id: 60,
        component: NewspaperViewerAlpha,
        path: "/home/newspaper-viewer-alpha",
        title: < span className=" d-center" > <sl-icon library="lucide" className="nav-icons" name="bot"></sl-icon>{" "}Newspaper Viewer Alpha</span >,
        permission: [roles.b2b] 
    },
    {
        id:62,
        component:BirdViewReject,
        path:'/home/birdview-reject',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="x-circle"></sl-icon>{" "}Rejected</span>,
        permission:[roles.b2b]
    },
    {
        id: 19,
        component: DefaultTab,
        path: "/home/competitor_data/get",
        title: < span className=" d-center" > <img src={nationalIcon} alt="" />{" "}Competitor Ads</span >,
        permission: [roles.b2b, roles.salesperson]
    },
    {
        id:61,
        component:AlphaBirdview,
        path:'/home/birdview-alpha',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="bot"></sl-icon>{" "}Competitor Ads Alpha</span>,
        permission:[roles.b2b]
    },
    {
        id: 23,
        component: CompetitorReports,
        path: "/home/competitor_reports/get",
        title: < span className="d-center" > <img src={competitorIcon} alt="" />{" "}Print Data</span >,
        permission: [roles.b2b, roles.salesperson, roles.ops]
    },
    {
        id: 72,
        component: PhionexReports,
        path: "/home/phionex_reports",
        title: < span className="d-center" > <sl-icon library="lucide" className="nav-icons" name="clipboard-list"></sl-icon>{" "}B2B Reports</span >,
        permission: [roles.b2b, roles.ops,roles.salesperson]
    },
    {
        id:82,
        component:AlphaCompetitorReports,
        path:"/home/alphacompetitor_reports/get",
        title: < span className ="d-center"> <img src={competitorIcon} alt=""/>{" "}Alpha Print Data</span>,
        permission:[roles.b2b, roles.salesperson, roles.ops]
    },
    {
        id: 83,
        component:InboundVernacular,
        path: "/home/inbound_vernacular",
        title: < span className="  d-center" > <img src={InfoIcon} style={{ width: "15px" }} alt="" />{" "}Inbound Vernacular</span >,
        permission: [roles.salesperson]
    },
    {
        id: 16,
        component: Contacts,
        path: "/home/b2b_contacts/get",
        title: < span className=" d-center" > <img src={b2bIcon} alt="" />{" "}B2B Contacts</span >,
        permission: [roles.b2b]
    },
    {
        id: 18,
        component: AgencyData,
        path: "/home/agency_data/get",
        title: < span className="  d-center" > <img src={agencyIcon} alt="" />{" "}Agency Data</span >,
        permission: [roles.b2b]
    },
    {
        id: 40,
        component: PageRates,
        path: "/home/page_rates",
        title: < span className="  d-center" > <img src={agencyIcon} alt="" />{" "}Page Rates</span >,
        permission: [roles.b2b]
    },
    {
        id: 41,
        component: Editions,
        path: "/home/editions",
        title: < span className="  d-center" > <img src={agencyIcon} alt="" />{" "}Editions</span >,
        permission: [roles.b2b]
    },
    {
        id: 17,
        component: Requests,
        path: "/home/b2b_requests/get",
        title: < span className="  d-center" > <img src={requestIcon} style={{ width: "15px" }} alt="" />{" "}Requests</span >,
        permission: [roles.b2b]
    },
    {
        id:73,
        component:CampaignInfo,
        path:"/home/campaign_info",
        title: < span className="  d-center" > <img src={InfoIcon} style={{ width: "15px" }} alt="" />{" "}Campaigns Info</span >,
        permission: [roles.b2b]
    },
    {
        id:76,
        component:AdCodeAlerts,
        path:'/home/adalerts',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="alert-triangle"></sl-icon>Adcode Alerts</span>,
        permission:[roles.ops]
    },
    // {
    //     id:55,
    //     component:NationalPlanning,
    //     path:'/home/planning',
    //     title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="target"></sl-icon>Planning</span>,
    //     permission:[roles.b2b]
    // },
    // {
    //     id:56,
    //     component:BuildupSheet,
    //     path:'/home/buildup',
    //     title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="trending-up"></sl-icon>Buildup</span>,
    //     permission:[roles.b2b]
    // },


    {
        id:59,
        component:HourlyStats,
        path:'/home/hourlystats',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="clock"></sl-icon>Hourly Stats</span>,
        permission:[roles.ops]
    },
    {
        id:65,
        component:Inventory,
        path:'/home/inventory',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="list"></sl-icon>Inventory</span>,
        permission:[roles.ops, roles.salesperson]
    },
    {
        id:68,
        component:AdResponses,
        path:'/home/adresponses',
        title:<span className="d-center"><sl-icon library="lucide" className="nav-icons" name="list"></sl-icon>Ad Responses</span>,
        permission:[roles.ops]
    },
    {
        id:45,
        component:TeamManagement,
        path:"/home/sales/teamManagement",
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="users"></sl-icon>Team Management</span>,
        permission:[roles.salesperson, roles.ops]   
    },
    {
        id:48,
        component:BrandsReport,
        path:'/home/brandsreport',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>Target vs Achieved</span>,
        permission:[roles.salesperson]
    },
    {
        id:66,
        component:AdPartners,
        path:'/home/adpartners',
        title:<span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>Ad Partners</span>,
        permission:[roles.ops]
    },
    
    {
        id: 3,
        component: Campaign,
        path: "/home/campaign",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="layout-grid"></sl-icon>Campaigns</span>,
        permission: [roles.ops, roles.financer]
    },
    {
        id: 4,
        component: ro,
        path: "/home/ro",
        title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="list-ordered"></sl-icon> {" "}RO</span>,
        permission: [roles.financer, roles.ops]
    },
    // {
    //     id: 5,
    //     component: Invoice,
    //     path: "/home/invoice",
    //     title: <span className=" d-center"> <sl-icon library="lucide" className="nav-icons" name="wallet"></sl-icon> {" "}Invoice</span>,
    //     permission: [roles.financer, roles.ops, roles.advertiser]
    // },
    {
        id: 10,
        component: CampaignDiscount,
        path: "/home/campaign_discount",
        title: <span className="text-base d-center"> <sl-icon library="lucide" name="percent"></sl-icon> {" "}Discount</span>,
        permission: [roles.ops, roles.financer, roles.salesperson]
    },
    {
        id: 11,
        component: Queued,
        path: "/home/networkads/queued",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="list-ordered"></sl-icon> {" "}Queued</span>,
        permission: [roles.network_ad_manager]
    },
    {
        id: 12,
        component: Approved,
        path: "/home/networkads/approved",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="check-circle-2"></sl-icon> {" "}Approved</span>,
        permission: [roles.network_ad_manager]
    },
    {
        id: 13,
        component: Blocked,
        path: "/home/networkads/blocked",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="x-circle"></sl-icon> {" "}Blocked</span>,
        permission: [roles.network_ad_manager]
    },
    {
        id:84,
        component:BrandLocations,
        path:"/home/brandlocations",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="x-circle"></sl-icon> {" "}BrandLocations</span>,
        permission: [roles.b2b]
        
    },
    {
        id:85,
        component:EenaduPageRates,
        path:"/home/eenadu/page_rates",
        title:<span className="text-base d-center"><sl-icon library="lucide" name="x-circle"></sl-icon>{" "}EenaduPageRates</span>,
        permission:[roles.b2b, roles.salesperson]
    },
    {
        id: 89,
        component: CashfreePaymentLinkCreation,
        path: "/home/cashfree_payment_link_creation",
        title: <span className="text-base d-center"><sl-icon library="lucide" name="x-circle"></sl-icon>{" "}Cashfree Payment Links</span>,
        permission: [roles.ops, roles.financer]
    }
    

]